export default "__VITE_ASSET__rGiQxnmG__"